import React, { useState, useEffect, useContext } from 'react';
import EditTransferBase from '../../EditTransfer'
import { ShopContext } from '../../contexts/Shop'
import { CustomerContext } from '../../contexts/Customer'
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { EnrollmentsContext } from '../../contexts/Enrollments'
import { SectionsProvider } from '../../contexts/Sections'

export default function EditTransfer(props) {
  const shop_name = useContext(ShopContext)
  const [customer] = useContext(CustomerContext)
  const subscriptions = useContext(SubscriptionsContext)
  const [enrollments, setEnrollments, upsertEnrollment] = useContext(EnrollmentsContext)

  const subscription = subscriptions.find((s) => s.id == props.subscription_id)

  return (<SectionsProvider value={subscription.sections}>
    <EditTransferBase
      forAccount={true}
      linkText='Wrong class? Click here.'
      shop_name={shop_name}
      cid={customer.id}
      id={subscription.enrollmentId}
      section_id={subscription.sectionId}
      onSave={upsertEnrollment}
      onSaving={props.onSaving} />
  </SectionsProvider>)
}
